export const musicCollection_8181 ={
    "@type": "Context",
    "id": 8181,
    "title": "2014 - 2018",
    "description": "02",
    "lastChanged": null,
    "changeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Tweak Style Feel",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Tweak Style Feel",
            "value": [
                {
                    "value": "Dance",
                    "selected": true
                },
                {
                    "value": "Electronic",
                    "selected": true
                },
                {
                    "value": "Folk",
                    "selected": true
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 2014,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 2014,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": false
                }
            ]
        }
    ],
    "defaultChangeableParameter": [
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Music Tweak Style Feel",
            "metadataDisplayType": "TEXT_CHECKBOX_SELECTION",
            "metadataDisplayName": "Music Tweak Style Feel",
            "value": [
                {
                    "value": "Dance",
                    "selected": true
                },
                {
                    "value": "Electronic",
                    "selected": true
                },
                {
                    "value": "Folk",
                    "selected": true
                },
                {
                    "value": "Pop",
                    "selected": true
                },
                {
                    "value": "Rock",
                    "selected": true
                }
            ]
        },
        {
            "@type": "ChangeableIntervalParameter",
            "name": "year",
            "metadataDisplayType": "NUMERIC_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "year",
            "minimum": 2014,
            "maximum": 2019,
            "step": 1,
            "lowerSelection": 2014,
            "upperSelection": 2019,
            "metadataDisplayMinimum": "-",
            "metadataDisplayMaximum": "+"
        },
        {
            "@type": "ChangeableSelectionParameter",
            "name": "Mood",
            "metadataDisplayType": "TEXT_SLIDER_RANGE_SELECTION",
            "metadataDisplayName": "Mood",
            "value": [
                {
                    "value": "Social",
                    "selected": true
                },
                {
                    "value": "Bright",
                    "selected": true
                },
                {
                    "value": "Dynamic",
                    "selected": false
                }
            ]
        }
    ],
    "visible": true,
    "editable": false,
    "favourite": false,
    "selected": false,
    "mostPlayed": false,
    "defaultSelected": true
};